// const API_CONFIG = "http://127.0.0.1:8000/api";
const API_CONFIG = process.env.REACT_APP_API_END_POINT+"api";
// const API_Local = "http://localhost:5000/api";
// const IMAGE_URL = "http://127.0.0.1:8000/";
const IMAGE_URL = process.env.REACT_APP_API_END_POINT;
// const PAGE_HOME_URL = "https://kentgo.com/home";
// const PAGE_PROFILE_URL = "https://kentgo.com/profile";

// const API_CONFIG = "http://localhost:8000/api";
// const API_Local = "http://localhost:5000/api";
// const IMAGE_URL = "http://localhost:8000/";
const PAGE_HOME_URL = process.env.REACT_APP_BASE_URL + "/home";
const PAGE_PROFILE_URL = process.env.REACT_APP_BASE_URL + "/profile";


const utils = {
  hostURL: (url) => {
    return `${API_CONFIG}${url}`;
  },
  imageURL: (url) => {
    return `${IMAGE_URL}${url}`;
  },
  LocalURL: (url) => {
    return `${API_Local}${url}`;
  },
  LocalHomePage: () => {
    return `${PAGE_HOME_URL}`
  },
  LocalProfilePage: () => {
    return PAGE_PROFILE_URL
  }
};

export default utils;
